/**
 * Single home for order-status → Ant Design tag colour mapping.
 * Keys must match the order-status enum used by the backend
 * (see backend/src/services/customerOrderStatusPolicy.js).
 *
 * Imported by: Profitability, Orders, Dashboard pages.
 */
export const ORDER_STATUS_COLORS: Record<string, string> = {
  NEW_INQUIRY: 'default',
  QUOTE_SENT: 'processing',
  CONFIRMED: 'blue',
  IN_FULFILLMENT: 'purple',
  READY_FOR_DISPATCH: 'lime',
  IN_DELIVERY: 'orange',
  PARTIALLY_DELIVERED: 'gold',
  ON_HOLD: 'magenta',
  DELIVERED: 'success',
  INVOICED: 'geekblue',
  CANCELLED: 'error',
};

export function getStatusTagColor(status: string): string {
  return ORDER_STATUS_COLORS[status] ?? 'default';
}
